import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { EventManager, AlertService } from 'ng-jhipster';

import { ITEMS_PER_PAGE, Principal, User, UserService } from '../../shared';
import {UtilsService} from '../../shared/utils/utils.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-user-mgmt',
    templateUrl: './user-management.component.html'
})
export class UserMgmtComponent implements OnInit, OnDestroy {
    currentAccount: any;
    users: User[];
    error: any;
    success: any;
    routeData: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    @ViewChild('dtUtilisateurs') dtUtilisateurs;
    multiSortMetaDtUtilisateurs: any[];

    private subscription: Subscription = new Subscription();

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private principal: Principal,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        public utilsService: UtilsService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
        this.page = data['pagingParams'].page;
        this.previousPage = data['pagingParams'].page;
        this.reverse = data['pagingParams'].ascending;
        this.predicate = data['pagingParams'].predicate;
        });
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.loadAll();
            this.registerChangeInUsers();
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    registerChangeInUsers() {
        this.subscription.add(this.eventManager.subscribe('userListModification', (response) => this.loadAll()));
    }

    loadAll () {
        this.subscription.add(this.userService.query({sort: this.sort()}).subscribe(
            (res: Response) => this.onSuccess(res.json()),
            (res: Response) => this.onError(res.json())
        ));
    }

    sort () {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private onSuccess(data) {
        data.forEach(d => {
            d.info = '';
            if (d.academicRegionLabel && d.academicRegionLabel.length > 0) {
                d.info = d.academicRegionLabel;
            }
            if (d.info.length > 0 && d.academyLabel && d.academyLabel.length > 0) {
                d.info += ' - ' + d.academyLabel;
            } else if (d.academyLabel && d.academyLabel.length > 0) {
                d.info =  d.academyLabel;
            }
            if (d.info.length > 0 && d.schoolName && d.schoolName.length > 0) {
                d.info += ' - ' + d.schoolName;
            } else if (d.info.length === 0) {
                d.info = d.schoolName;
            }
            d.authoritiesString = this.utilsService.getAuthoritiesString(d.authorities);
        });
        this.users = data;
    }

    private onError(error) {
        this.alertService.error(error.error, error.message, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management.component.ts